import { colors, palette, typography, radius } from 'theme/tokens';

const { fontSizePx, fontWeight, lineHeight } = typography;
const brandAlpha = colors.partnerConsoleAlpha;

const defaultTheme = {
  token: {
    colorPrimary: colors.partnerConsole.primary,
    colorSuccess: colors.partnerConsole.success,
    colorWarning: colors.status.warning,
    colorError: colors.status.error,
    colorInfo: colors.status.info,
    colorBgLayout: colors.partnerConsole.layoutBg,
    colorBgContainer: palette.white,
    colorTextBase: colors.partnerConsole.textBase,
    colorTextSecondary: colors.partnerConsole.textSecondary,
    colorBorder: colors.partnerConsole.border,
    colorBorderSecondary: colors.partnerConsole.borderSecondary,
    borderRadius: radius.md,
    borderRadiusLG: radius.xl,
    borderRadiusSM: radius.sm,
    fontFamily: typography.fontFamily.inter,
    fontSize: fontSizePx[12],
    fontSizeHeading1: fontSizePx[24],
    fontSizeHeading2: fontSizePx[20],
    fontSizeHeading3: fontSizePx[16],
    fontSizeHeading4: fontSizePx[14],
    fontSizeHeading5: fontSizePx[12],
    fontWeightStrong: fontWeight.semiBold,
    lineHeight: lineHeight.loose,
    lineHeightHeading1: lineHeight.snug,
    lineHeightHeading2: 1.35,
    lineHeightHeading3: lineHeight.normal,
    lineHeightHeading4: 1.45,
    controlHeight: 36,
    controlHeightSM: 28,
    paddingContentHorizontal: 16,
    paddingContentVertical: 12,
    // Flatten shadows — use minimal or none
    boxShadow: 'none',
    boxShadowSecondary: `0 1px 3px ${palette.alpha.black[4]}`,
    boxShadowTertiary: 'none',
  },
  components: {
    Form: {
      labelRequiredMarkColor: colors.status.error,
    },
    Layout: {
      siderBg: colors.partnerConsole.siderBg,
      headerBg: palette.white,
      bodyBg: colors.partnerConsole.layoutBg,
    },
    Menu: {
      darkItemBg: colors.partnerConsole.siderBg,
      darkSubMenuItemBg: colors.partnerConsole.subMenuBg,
      darkItemSelectedBg: brandAlpha[20],
      darkItemHoverBg: brandAlpha[8],
      itemHeight: 42,
      iconSize: 18,
      collapsedIconSize: 20,
      itemMarginInline: 8,
      itemBorderRadius: radius.md,
    },
    Card: {
      paddingLG: 20,
      borderRadiusLG: radius.lg,
      boxShadowTertiary: 'none',
      headerFontSize: fontSizePx[14],
      headerFontSizeSM: fontSizePx[12],
    },
    Table: {
      headerBg: colors.partnerConsole.tableHeaderBg,
      headerColor: colors.partnerConsole.textSecondary,
      headerSplitColor: 'transparent',
      rowHoverBg: colors.partnerConsole.rowHoverBg,
      cellPaddingBlockSM: 10,
      cellPaddingInlineSM: 12,
      fontSize: fontSizePx[12],
      borderColor: colors.partnerConsole.borderSecondary,
    },
    Button: {
      borderRadius: radius.md,
      controlHeight: 36,
      controlHeightSM: 28,
      fontWeight: fontWeight.medium,
      primaryShadow: 'none',
      defaultShadow: 'none',
      dangerShadow: 'none',
    },
    Tag: {
      borderRadiusSM: radius.sm,
      fontSize: fontSizePx[12],
    },
    Tabs: {
      titleFontSize: fontSizePx[12],
      titleFontSizeLG: fontSizePx[14],
      inkBarColor: colors.partnerConsole.primary,
    },
    Modal: {
      borderRadiusLG: radius.xl,
      paddingContentHorizontalLG: 24,
    },
    Alert: {
      borderRadiusLG: radius.md,
    },
    Descriptions: {
      labelBg: colors.partnerConsole.tableHeaderBg,
      fontSize: fontSizePx[12],
    },
    Steps: {
      fontSize: fontSizePx[12],
    },
    Input: {
      borderRadius: radius.md,
      activeShadow: `0 0 0 2px ${brandAlpha[8]}`,
      hoverBorderColor: colors.partnerConsole.primary,
    },
    Select: {
      borderRadius: radius.md,
    },
    DatePicker: {
      borderRadius: radius.md,
    },
    Breadcrumb: {
      fontSize: fontSizePx[12],
    },
    Badge: {
      fontSize: fontSizePx[12],
      fontSizeSM: fontSizePx[10],
    },
    Timeline: {
      fontSize: fontSizePx[12],
    },
    Statistic: {
      titleFontSize: fontSizePx[12],
      contentFontSize: fontSizePx[22],
    },
  },
};

export default defaultTheme;
